<ng-container *transloco="let t; prefix: 'labels.edit-label'">
  <xi-input-field
    appAutoFocus="xiInput"
    autoFocusTimeout="150"
    appAutocompleteOff="xiInput"
    autocompleteOffTimeout="100"
    name="label"
    [disabled]="isProcessing"
    [(ngModel)]="searchValue"
    [maxCharsAllowed]="{
      max: 20,
      allowOvertype: !!label,
      errorMessage: t('label-too-long', { maxLength: 20 }),
    }"
    [status]="labelInputStatus"
    [suggestions]="labelSuggestions"
    (onSuggestionClick)="onSuggestionSelected($event.detail.suggestion)"
    (onChange)="searchSubject.next($event.detail.target.value)"
    (onInputEnter)="updateOrApplyOrCreate()"
    (keyup.escape)="cancel.emit()"
  ></xi-input-field>

  @if (label) {
    <div class="xi-loader-button-container">
      <xi-default-button
        [text]="t('save-label')"
        [disabled]="isProcessing || hasError || !hasChanges"
        (onClick)="updateOrApplyOrCreate()"
      ></xi-default-button>

      @if (isProcessing) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>

    <xi-icon-button
      icon="trash"
      color="error"
      [disabled]="isProcessing"
      (onClick)="remove()"
    ></xi-icon-button>
  } @else {
    <div class="xi-loader-button-container">
      <xi-default-button
        [text]="t('add-label')"
        [disabled]="isProcessing || hasError"
        (onClick)="applyOrCreate()"
      ></xi-default-button>

      @if (isProcessing) {
        <div class="xi-loader-container__inline-overlay">
          <xi-animation
            [height]="75"
            [width]="75"
            [loop]="true"
            animation="cx_loader"
          ></xi-animation>
        </div>
      }
    </div>
  }
</ng-container>
